import { render, staticRenderFns } from "./garden9.vue?vue&type=template&id=4dd5742b"
import script from "./garden9.vue?vue&type=script&lang=js"
export * from "./garden9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports